import { Entypo } from '@native-base/icons';
import {
  Center,
  Heading,
  HStack,
  Icon,
  ScrollView,
  Spacer,
  StatusBar,
  Text,
} from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import moneyDisplay from '../../../helpers/moneyDisplay';
import ActionButton from '../../../shared/ActionButton';
import FacesInput from '../../../shared/FacesInput';

function Returns({
  onDone,
  onreturnAdd,
  onreturnSub,
  remaining,
  returnContent,
}) {
  return (
    <>
      <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
      <Center bg="#F4F8FB" shadow="3" px="4" py="4">
        <Heading size="sm">À recevoir</Heading>
        <HStack alignItems="center" justifyContent="center">
          <Icon as={Entypo} name="arrow-bold-down" color="green.500" mr="2" />
          <Heading color={remaining ? 'red.500' : 'green.500'}>
            {moneyDisplay(remaining)}
          </Heading>
        </HStack>
      </Center>
      <Center bg="#caf0f8" px="4" py="2">
        <Text>Sélectionnez les billets et pièces reçus en retour.</Text>
      </Center>
      <ScrollView px="4" py="2">
        <FacesInput
          content={returnContent}
          onAdd={onreturnAdd}
          onSub={onreturnSub}
        />
      </ScrollView>
      <Spacer />
      <ActionButton onPress={onDone}>Continuer</ActionButton>
    </>
  );
}

Returns.propTypes = {
  remaining: PropTypes.number.isRequired,
  onDone: PropTypes.func.isRequired,
  returnContent: PropTypes.array.isRequired,
  onreturnAdd: PropTypes.func.isRequired,
  onreturnSub: PropTypes.func.isRequired,
};

export default Returns;
